import {
  // getEventData,
  siteEventNames,
} from '../events/site-events';

export default () => {
  window.addEventListener(siteEventNames.ON_MODAL_OPEN, () => {
    // const data = getEventData(siteEventNames.ON_MODAL_OPEN);
    // Hide chat icon
    const chatIconDiv = document.getElementById('genesys-messenger');
    if (chatIconDiv) {
      chatIconDiv.style.display = 'none';
    }
  });
  window.addEventListener(siteEventNames.ON_MODAL_CLOSE, () => {
    // const data = getEventData(siteEventNames.ON_MODAL_CLOSE);
    // Show chat icon
    const chatIconDiv = document.getElementById('genesys-messenger');
    if (chatIconDiv) {
      chatIconDiv.style.display = 'block';
    }
  });
};
